import { gql } from '@apollo/client';

export const MUTATION_CREATE_BUSINESS_ENTITY = gql`
    mutation CreateBusinessEntity($data: CreateBusinessEntityInput!) {
        createBusinessEntity(data: $data) {
            id
            description
            displayName
            customDisplayName
            enabled
            entityTypes {
                id
                name
            }
            captureId
            captureLink
            createdAt
            createdBy {
                id
                name
            }
            einNumber
            freightThreshold
            level
            tagline
            images
            ownerTenant {
                id
                name
            }
            productThreshold
            representedTenant {
                id
                name
            }
            taxIdentificationNum
            updatedAt
            updatedBy {
                id
                name
            }
            associatedTenants {
                id
                name
            }
            arContact {
                id
            }
            apContact {
                id
            }
            remitTo {
                id
            }
            legalName
            website
            password
            customerNumber
            keyIdentifiers
            vendorNumber
            geographicLocation {
                id
                value
            }
            tagline
            logo
            images
        }
    }
`;

export const MUTATION_UPDATE_BUSINESS_ENTITY = gql`
    mutation UpdateBusinessEntity($data: UpdateBusinessEntityInput!) {
        updateBusinessEntity(data: $data) {
            id
            description
            displayName
            customDisplayName
            enabled
            entityTypes {
                id
                name
            }
            captureId
            captureLink
            createdAt
            createdBy {
                id
                name
            }
            einNumber
            freightThreshold
            level
            tagline
            images
            ownerTenant {
                id
                name
            }
            productThreshold
            representedTenant {
                id
                name
            }
            taxIdentificationNum
            updatedAt
            updatedBy {
                id
                name
            }
            associatedTenants {
                id
                name
            }
            arContact {
                id
            }
            apContact {
                id
            }
            remitTo {
                id
            }
            address {
                id
            }
            legalName
            website
            password
            customerNumber
            keyIdentifiers
            vendorNumber
            geographicLocation {
                id
                value
            }
            tagline
            logo
            images
        }
    }
`;

export const MUTATION_SET_PREFERRED_BUSINESS_ENTITIES = gql`
    mutation SetPreferredBusinessEntities($data: SetPreferredBusinessEntitiesInput!) {
        setPreferredBusinessEntities(data: $data) {
            preferredEntityIds
        }
    }
`;
export const MUTATION_BULK_UPDATE_BUSINESS_ENTITY = gql`
    mutation BulkUpdateBusinessEntities($data: UpdateManyBusinessEntitiesInput!) {
        bulkUpdateBusinessEntities(data: $data) {
            id
            description
            displayName
            customDisplayName
            enabled
            entityTypes {
                id
                name
            }
            captureId
            captureLink
            createdAt
            createdBy {
                id
                name
            }
            einNumber
            freightThreshold
            level
            ownerTenant {
                id
                name
            }
            productThreshold
            representedTenant {
                id
                name
            }
            taxIdentificationNum
            updatedAt
            updatedBy {
                id
                name
            }
            associatedTenants {
                id
                name
            }
            arContact {
                id
            }
            apContact {
                id
            }
            remitTo {
                id
            }
            legalName
            website
            password
            customerNumber
            keyIdentifiers
            vendorNumber
            tagline
            logo
            images
        }
    }
`;

export const MUTATION_BULK_CREATE_BUSINESS_ENTITY = gql`
    mutation BulkCreateBusinessEntities($data: CreateManyBusinessEntitiesInput!) {
        bulkCreateBusinessEntities(data: $data) {
            id
            description
            displayName
            customDisplayName
            enabled
            entityTypes {
                id
                name
            }
            captureId
            captureLink
            createdAt
            createdBy {
                id
                name
            }
            einNumber
            freightThreshold
            level
            ownerTenant {
                id
                name
            }
            productThreshold
            representedTenant {
                id
                name
            }
            taxIdentificationNum
            updatedAt
            updatedBy {
                id
                name
            }
            associatedTenants {
                id
                name
            }
            arContact {
                id
            }
            apContact {
                id
            }
            address {
                id
            }
            remitTo {
                id
            }
            legalName
            website
            password
            customerNumber
            keyIdentifiers
            vendorNumber
            tagline
            logo
            images
        }
    }
`;
